import { render, staticRenderFns } from "./MobileSubmenu.vue?vue&type=template&id=3dd57ac4&scoped=true&"
import script from "./MobileSubmenu.vue?vue&type=script&lang=js&"
export * from "./MobileSubmenu.vue?vue&type=script&lang=js&"
import style0 from "./MobileSubmenu.vue?vue&type=style&index=0&id=3dd57ac4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd57ac4",
  null
  
)

export default component.exports